import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

import partsCategories from '../partsCategories';
import PartCategorySelector from './PartCategorySelector';
import PartSelector from './PartSelector';
import PFPPreview from './PFPPreview';
import SelectionLabel from './SelectionLabel';
import { VerticalSpacer10, VerticalSpacer20 } from './Spacers';
import DownloadButton from './DownloadButton';
import { usePFPGeneratorContext } from '../contexts/PFPGeneratorContext';
import MobileDeviceImageDownloadOverlay from './MobileDeviceImageDownloadOverlay';
import Button from './Button';
import OrSeparator from './OrSeparator';
import PartColorSelector from './PartColorSelector';
import generateRandomSelectedParts from '../utils/generateRandomSelectedParts';
import generateRandomSelectedColors from '../utils/generateRandomSelectedColors';

export default () => {
  const {
    mobileDevicePFPImageDataUri,
    selectedParts,
    setSelectedParts,
    selectedColors,
    setSelectedColors,
  } = usePFPGeneratorContext();

  const [selectedCategoryID, setSelectedCategoryID] = useState<string>(
    partsCategories[0].name
  );

  const handleLeftOrRightButtonPress = (direction: 'left' | 'right') => {
    const isLeft = direction === 'left';

    const newSelectedParts = { ...selectedParts };
    const currentPartsCategory = partsCategories.find(
      (category) => category.name === selectedCategoryID
    );
    const indexOfNewPart =
      currentPartsCategory.children.indexOf(selectedParts[selectedCategoryID]) +
      (isLeft ? -1 : 1);
    const indexOfNewPartWithinArrayBounds =
      indexOfNewPart >= 0 &&
      indexOfNewPart < currentPartsCategory.children.length
        ? indexOfNewPart
        : isLeft
        ? currentPartsCategory.children.length - 1
        : 0;
    const newSelectedPart =
      currentPartsCategory.children[indexOfNewPartWithinArrayBounds];
    newSelectedParts[selectedCategoryID] = newSelectedPart;
    setSelectedParts(newSelectedParts);
  };

  const handleRandomizeButtonPress = () => {
    setSelectedParts(generateRandomSelectedParts());
    setSelectedColors(generateRandomSelectedColors());
  };

  return (
    <View style={styles.container}>
      <View style={styles.controlsContainer}>
        <Button title="Randomize" onPress={handleRandomizeButtonPress} />
        <OrSeparator />
        <PartCategorySelector
          onCategorySelected={(categoryId) => setSelectedCategoryID(categoryId)}
          selectedCategoryID={selectedCategoryID}
        />
      </View>
      <PartColorSelector
        selectedCategoryID={selectedCategoryID}
        selectedColor={selectedColors[selectedCategoryID]}
        onColorSelected={(assetColor) => {
          setSelectedColors({
            ...selectedColors,
            [selectedCategoryID]: assetColor,
          });
        }}
      />
      <VerticalSpacer10 />
      <View style={styles.previewContainer}>
        <PFPPreview />
        <PartSelector
          onLeftPress={() => {
            handleLeftOrRightButtonPress('left');
          }}
          onRightPress={() => {
            handleLeftOrRightButtonPress('right');
          }}
        />
      </View>
      <SelectionLabel
        selectedCategoryID={selectedCategoryID}
        selectedParts={selectedParts}
      />
      <View style={styles.buttonContainer}>
        <VerticalSpacer20 />
        <DownloadButton selectedParts={selectedParts} />
      </View>
      {mobileDevicePFPImageDataUri && <MobileDeviceImageDownloadOverlay />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 640,
  },
  controlsContainer: { width: '100%' },
  previewContainer: {
    width: '100%',
  },
  buttonContainer: {
    width: '100%',
  },
});
